module.exports = __webpack_public_path__ + "fonts/Alga-LightItalic.5de42db8.woff";